import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
} from "@mui/material";
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";
import useTeamsSdk from "../hooks/useTeamsSdk";

export default function MainPanel() {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const joinUrl = decodeURIComponent(params.get("joinUrl") || "");
  const meetingId = decodeURIComponent(params.get("meetingId") || "");

  // ================== Functions ====================================================================

  const { metrics, coachingLogs } = useTeamsSdk(joinUrl, meetingId);

  return (
    <div className="App">
      {/* Main UI */}
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "grey.100",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "primary.main",
            color: "white",
            px: 2,
            py: 1,
            flexWrap: isSmallScreen ? "wrap" : "nowrap",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: isSmallScreen ? "wrap" : "nowrap",
            }}
          ></Box>
        </Box>

        {/* Main Content */}
        <Box sx={{ flex: 1, p: 2 }}>
          {/* Meeting Metrics */}
          <Card sx={{ mb: 4 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Meeting Metrics
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: isSmallScreen ? "1fr" : "repeat(3, 1fr)",
                  gap: 2,
                }}
              >
                {[
                  { title: "Score", value: metrics.score },
                  { title: "Engagement", value: metrics.engagement },
                  { title: "Sentiment", value: metrics.sentiment },
                ].map((metric, index) => (
                  <Card
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      bgcolor: "grey.100",
                      p: 2,
                    }}
                  >
                    <Typography
                      variant="h5"
                      color="text.primary"
                      fontWeight="bold"
                    >
                      {metric.value}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {metric.title}
                    </Typography>
                  </Card>
                ))}
              </Box>
            </CardContent>
          </Card>

          {/* Coaching Section */}
          <Card sx={{ mt: 4, mb: 4 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Coaching
              </Typography>
              <Box
                sx={{
                  maxHeight: "250px",
                  overflowY: "auto",
                  bgcolor: "grey.50",
                  p: 1,
                  borderRadius: 1,
                }}
              >
                {coachingLogs.length === 0 ? (
                  <Typography>No coaching tips yet.</Typography>
                ) : (
                  coachingLogs.map((log, index) => (
                    <Typography key={index} variant="body2" sx={{ mb: 1 }}>
                      {`${log.timestamp} - ${log.suggestion}`}
                    </Typography>
                  ))
                )}
              </Box>

              {/* Disclaimer */}
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mt: 2 }}
              >
                AI-generated content may be incorrect.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Box>
    </div>
  );
}
